export default {
  'Welcome!': 'Vítejte!',
  'Joint ID': 'ID  spoje',
  'Joint Log': 'Záznam o spoji',
  'Home': 'Domů',
  'ID': 'ID ',
  'Alarm': 'Alarm',
  'temps': 'čas',
  'Temperature': 'Teplota',
  'Joints': 'Spoje',
  'Current Report': 'Aktuální report',
  'Current Equipment': 'Aktuální vybavení',
  'Joints welded over time': 'Spoje svařeny za uvedené období',
  'Equipment': 'Vybavení',
  ' Equipment': 'Vybavení',
  'Timestamp': 'Časové razítko',
  'timestamp': 'Časové razítko',
  'Welds': 'Svary',
  'Actions': 'Akce',
  'Report Preview': 'Náhled reportu',
  'Page:': 'Strana',
  'Filters': 'Fitry',
  'This Week': 'Tento týden',
  'This Month': 'Tento měsíc',
  'This Year': 'Tento rok',
  'January_February_March_April_May_June_July_August_September_October_November_December': 'Leden_Únor_Březen_Duben_Květen_Červen_Červenec_Srpen_Září_Říjen_Listopad_Prosinec',
  'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': '',
  'Mo_Tu_We_Th_Fr_Sa_Su': 'Po_Út_St-Čt-Pá_So_Ne',
  'Previous': 'Předchozí',
  'Reloading data..': 'Načítám data',
  'Data reloaded': 'Data načtena',
  'Add to report': 'Přidat do reportu',
  'Next': 'Další',
  'Rental Start Date': 'Začátek pronájmu',
  'Rental End Date': 'Konec pronájmu',
  'Map': 'Mapa',
  'Password': 'Heslo',
  'The password is required!': 'Je požadováno heslo',
  'Password must be at least {1} characters': 'Heslo usí být alespoň {1} jeden znak',
  'Create User': 'Vytvoření uživatele',
  'First Name': 'Jméno',
  'Last Name': 'Příjmení',
  'E-mail': 'E-mail',
  'User list': 'Seznam uživatelů',
  'Create new user': 'Vytvoření nového uživatele',
  'Edit': 'Zadávání',
  'Delete': 'Vymazat',
  'User Profile': 'Profil uživatele',
  'Save': 'Uložit',
  'User Companies': 'Společnosti uživatele',
  'Select companies': 'Vyber společnost',
  'Save Companies': 'Ulož společnost',
  'Welding Report': 'Svářecí report',
  'Welding Machine': 'Svářecí stroj',
  'Welding Machines': 'Svářecí stroje',
  'Created by:': 'Vytvořeno',
  'Company:': 'Společnost',
  'of': 'z',
  'Remove': 'Vyjmout',
  'Clear Report': 'Vyčistit report',
  'Preview Report': 'Náhled reportu',
  'Print Report': 'Vytisknout report',
  'Are you sure?': 'Jste si jistý/á',
  'Sign In to your account': 'Přihlaš se do svého účtu',
  'Email': 'Email',
  'Forgot password?': 'Zapoměnuté heslo?',
  'Logging in..': 'Přihlaš se',
  'Access Denied': 'Přístup odepřen',
  'Map (Only shows welding machines)': 'Mapa (Zobrazuje pouze svářecí stroje)',
  'All': 'Všechno',
  'Machine ID': 'ID svářecího stroje',
  'icon-110': 'znak-110',
  'Ongoing': 'Probíhající',
  'Historical equipment rentals': 'Pronajaté vybavení v minulosti ',
  'On': 'Zapnuto',
  'Off': 'Vypnuto',
  'Equipment ID (If applicable)': 'ID přístroje (poku existuje)',
  'Description': 'Popis',
  'Write a description of what happened..': 'uveďte popis co se stalo',
  'Alert customer to send back equipment': 'Upozorněte zákazníka aby poslal zpět zařízení',
  'Date': 'Datum',
  'Reason': 'Důvod',
  'Created by': 'Vytvořeno kým',
  'Customer Log': 'Protokol zákazníka',
  'Create Log Entry': 'Vytvoř záznam protokolu',
  'Support - Phone': 'Podpora - Telefon',
  'Support - E-mail': 'Podpora - E.mail',
  'Sales - Phone': 'Prodej - Telefon',
  'Sales Activity - Campaign, Email etc.': 'Prodejní aktivity - kampaně, E.mail atd.',
  'Slug': '',
  'Subject': 'Předmět',
  'Email Templates': 'Předloha emailu',
  'Revision Date': 'Datum revize',
  'CPU': 'CPU/Procesor',
  'Filename 1': 'Název souboru 1',
  'Filename 2': 'Název souboru 2',
  'Revisions': 'Revize',
  'Revision': 'Revize',
  'Upload new revision': 'Nahraj novou revizi',
  'Equipment ID': 'ID přístroje',
  '# CPUs': '# CPUs/procesorů',
  'Create Equipment Specification': 'Vytvoř specifikaci přístroje',
  'Display': 'Displej',
  'Styrkort': '',
  'Latest rev CPU 1': 'Poslední revize CPU 1',
  'Latest rev CPU 2': 'Poslední nrevize CPU 2',
  'Equipment Specifications': 'Specifikace zařízení',
  'Create specification': 'Vytvoř specifikaci',
  'Old': 'Starý',
  'New': 'Nový',
  'Create Update Entry': 'Vytvoř aktualizaci',
  'Update Queue': 'Obnov frontu',
  'Create update entry': 'Vytvoř obnovovací zápis',
  '[Welcome Title]': 'Vítejte',
  '[Welcome Body]': 'Tento webový portál Vám umožní získat podrobné informace o spojích, které jsou provedeny ve Vaší společnosti. Pro navigaci používejte Menu na pravé straně.',
  'Number of joints': 'Počet spojů',
  'Dimension': 'Dimenze',
  'Select a Machine ID': 'Vyber ID přístroje',
  'Choose the equipment related to your message (optional)': 'Vyber vybavení odpovídající tvé zprávě (volitelné)',
  '-- Nothing Selected --': 'Nic nevybráno',
  'Message': 'Zpráva',
  'Write your message here': 'Napiš svoji zprávu zde',
  'I want to send back the equipment': 'Chci zaslat zpět vybavení',
  'Contact Support': 'Kontaktuj podporu',
  'Send message': 'Pošli zprávu',
  'Login': 'Přihlášení',
  'Logout': 'Odhlášení',
  'Users': 'Uživatelé',
  'Firmware Revisions': 'Revize Firmware',
  'Equipment Spec.': 'Specifikace vybavení',
  'Remote Update': 'Dálková aktualizace',
  'Dashboard': 'Hlavní stránka',
  'Current': 'Současný',
  'Historical': 'Historický',
  'Weld Report': 'Svářecí report',
  'Weld Report for ': 'Svářecí report pro',
  'Support': 'Podpora',
  'joint_time_a': 'čas_spoje_a',
  'u_mains': 'u_napájení',
  'mode': 'režim',
  'alarm': 'alarm',
  'channel': 'kanál',
  'dimension': 'dimenze',
  'name': 'jméno',
  'Report Name:': 'Jméno reportu',
  'Comment': 'Komentář',
  'Joint Comment': 'Komentář',
  'Write a report name.. (optional)': 'Napište jméno reportu .. (volitelné)',
  'Report name:': 'Jméno reportu',
  'Add all to report': 'Všechno přidej do reportu',
  'Per page': 'Na stránku',
  'ALARM-0': 'ALARM-0',
  'ALARM-1': 'ALARM-1',
  'ALARM-2': 'ALARM-2',
  'ALARM-4': 'ALARM-4',
  'ALARM-8': 'ALARM-8',
  'ALARM-16': 'ALARM-16',
  'ALARM-32': 'ALARM-32',
  'ALARM-64': 'ALARM-64',
  'ALARM-128': 'ALARM-128',
  'TIME-min': 'ČAS-min',
  'TIME-sec': 'ČAS-sec',
  'Seconds': 'Sekundy',
  'Minutes': 'Minuty',
  'Select a Dimension': 'Vyber dimenzi'
}



// WEBPACK FOOTER //
// ./src/translations/cz.js